import request from '@/utils/request'; // 新增

export function insert(data) {
  return request({
    url: '/pmsservice/api/houseMeter/insert',
    method: 'post',
    data: data
  });
} // 修改

export function update(data) {
  return request({
    url: '/pmsservice/api/houseMeter/update',
    method: 'post',
    data: data
  });
} // 查询

export function fetchList(data) {
  return request({
    url: '/pmsservice/api/houseMeter/list',
    method: 'post',
    data: data
  });
} // 查询详情（换表详情）

export function getDetail(data) {
  return request({
    url: '/pmsservice/api/houseMeter/get',
    method: 'post',
    data: data
  });
} // 删除

export function fetchDelete(data) {
  return request({
    url: '/pmsservice/api/houseMeter/delete',
    method: 'post',
    data: data
  });
} // 换表 （原数据设为不可用，新增一条数据）

export function changeTable(data) {
  return request({
    url: '/pmsservice/api/houseMeter/changeTable',
    method: 'post',
    data: data
  });
} // 批量添加

export function insertBatch(data) {
  return request({
    url: '/pmsservice/api/houseMeter/insertBatch',
    method: 'post',
    data: data
  });
} // 房间下拉

export function getHouseListTree(data) {
  return request({
    url: '/pmsservice/api/houseMeter/houseList',
    method: 'post',
    data: data
  });
} // 获取楼栋单元列表

export function getHouseList(data) {
  return request({
    url: '/pmsservice/api/house/list',
    method: 'post',
    data: data
  });
} // --------------------------公摊表----------------------------
// 查询公摊表

export function fetchShareMeterList(data) {
  return request({
    url: '/pmsservice/api/shareMeter/list',
    method: 'post',
    data: data
  });
} // 新增

export function insertShare(data) {
  return request({
    url: '/pmsservice/api/shareMeter/insert',
    method: 'post',
    data: data
  });
} // 修改

export function updateShare(data) {
  return request({
    url: '/pmsservice/api/shareMeter/update',
    method: 'post',
    data: data
  });
} // 查询详情（换表详情）

export function getShareDetail(data) {
  return request({
    url: '/pmsservice/api/shareMeter/get',
    method: 'post',
    data: data
  });
} // 删除

export function fetchShareDelete(data) {
  return request({
    url: '/pmsservice/api/shareMeter/delete',
    method: 'post',
    data: data
  });
} // 换表 （原数据设为不可用，新增一条数据）

export function changeShareTable(data) {
  return request({
    url: '/pmsservice/api/shareMeter/changeTable',
    method: 'post',
    data: data
  });
} // 查询小区名称（树）

export function selectPmsTreeWithArea(data) {
  return request({
    url: '/pmsservice/api/pmsTree/selectPmsTreeWithArea',
    method: 'post',
    data: data
  });
} // 查询小区名称

export function selectManagerArea() {
  return request({
    url: '/pmsservice/api/area/selectManagerArea',
    method: 'post'
  });
} // 查询分摊仪表树

export function selectMeterTreeList(data) {
  return request({
    url: '/pmsservice/api/publicMethod/meterTreeList',
    method: 'post',
    data: data
  });
} // 查询房屋（树）

export function houseTreeList(data) {
  return request({
    url: '/pmsservice/api/publicMethod/houseTreeList',
    method: 'post',
    data: data
  });
}